import React from 'react';
import Button, { ButtonProps } from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1),
  },
  buttonPrimary: {
    margin: theme.spacing(1),
    backgroundColor: '#597DDA',
    minWidth: '188px',
    minHeight: '50px',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#466CCE',
    }
  },
  buttonSecondary: {
    margin: theme.spacing(1),
    backgroundColor: '#FFFFFF',
    border: '1px solid #597DDA',
    minWidth: '188px',
    minHeight: '50px',
    color: '#597DDA',
    '&:hover': {
      backgroundColor: '#F8F9FB',
      borderColor: '#597DDA',
    }
  },
  input: {
    display: 'none',
  }
}));

export default function ButtonUI(props: ButtonProps) {
  const classes = useStyles();
  let color = "";

  if (props.color === "primary") {
    color = classes.buttonPrimary
  }
  else {
    color = classes.buttonSecondary
  }

  return (<Button className={color} {...props} ></Button>);
}